export function checkPhone(phone){
  if (!phone) return false;
  if (!(/^1[3456789]\d{9}$/.test(phone))) return false;
  return true;
}